export enum UserUpdateOperations {
    DELETE = "DELETE",
    MERGE = "MERGE",
    UPDATE = "UPDATE",
}